export function normalizeDateForBackend(date) {
  return date.utc().date()
}
